import React from "react";

import { useTracking } from "react-tracking";
import { useDispatch, useSelector } from "react-redux";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";
import AdminDataAlternativeRoutes from "./AdminDataAlternativeRoutes";

const AdminDataAlternativeScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Import Data Alternative",
      page: "Import Data Alternative Screen",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {

        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );

  return (
    <div>
      <Track>
        <AdminDataAlternativeRoutes />
      </Track>
    </div>
  );
};

export default AdminDataAlternativeScreen;
